import { setAttr, removeAttr, getElement, updateElement } from '@/libs/util';
import {
  existsElement,
  invokeUpdateCurrentPrice,
  updateGlobalVariableByElement,
  updateGlobalVariable,
  setContentToElement,
} from '@/libs/cart/subtotal/util';
import {
  updatePriceElement,
  updateElement as updateElementForCurrentPrice,
} from '@/libs/cart/subtotal/currentPrice';

import {
  show,
  isDecreased,
  createMessage,
  invokeCartSuccessPopupAction,
  showElement,
  invokeShowPopup,
} from '@/libs/cart/subtotal/popup';

import {
  addClass,
  removeClass,
  existsChildElement,
  isChildElementForJustOne,
  isEmptyText,
  updateElement as updateElementForCarriageFee,
  updateGlobalVariableAfterChange,
  updateGlobalVariableBeforeChange,
  updateGlobalVariableByAttr,
  updateGlobalVariableByChildElement,
  updateGlobalVariableForSup,
  updateWcContent,
  setCurrentAttr,
  setRestAttr,
  setDiscountedAttr,
  updateGlobalVariableForWc,
} from '@/libs/cart/subtotal/carriageFee';

import {
  show as showVitality,
  updateWcContent as updateWcContentOfVitality,
} from '@/libs/cart/subtotal/vitality';

declare global {
  interface Window {
    cart: any;
  }
}

window.cart = {};

window.cart.subtotal = {};

window.cart.subtotal.finishLoading = updateElement(
  getElement,
  setAttr,
  '#cart-bar',
  'loading',
  'false'
);

window.cart.subtotal.currentPrice = {};

window.cart.subtotal.currentPrice.invokeUpdateCurrentPrice = invokeUpdateCurrentPrice(
  '*[name=current_price]',
  '#cart-bar',
  existsElement
);

window.cart.subtotal.currentPrice.updateCurrentPriceVariable = updateGlobalVariableByElement(
  '[name=current_price]',
  existsElement,
  '#cart-bar',
  getElement,
  window,
  'currentPrice',
  'subtotal',
  updateGlobalVariable
);

window.cart.subtotal.currentPrice.updateBeforeCurrentPriceVariable = updateGlobalVariableByElement(
  '[name=current_price]',
  existsElement,
  '#cart-bar',
  getElement,
  window,
  'beforeCurrentPrice',
  'subtotal',
  updateGlobalVariable
);

window.cart.subtotal.currentPrice.updateElement = updateElementForCurrentPrice(
  existsElement,
  updatePriceElement,
  '*[name=current_price]',
  getElement,
  setAttr,
  '#cart-bar',
  'subtotal',
  'total'
);

window.cart.subtotal.popup = {};

window.cart.subtotal.popup.show = show(
  isDecreased,
  createMessage,
  invokeCartSuccessPopupAction,
  'isCartAutoCompleteUser' in window
);

window.cart.subtotal.popup.showElement = showElement(
  '#cart-bar',
  getElement,
  invokeShowPopup
);

window.cart.subtotal.vitality = {};

window.cart.subtotal.vitality.show = showVitality(
  existsElement,
  setContentToElement,
  getElement,
  setAttr,
  updateWcContentOfVitality,
  '#vitalityDiscountForFooter',
  '#cart-bar',
  'vitality-discount-tax-excluded',
  'vitality-discount-tax-included'
);

window.cart.subtotal.carriageFee = {};

window.cart.subtotal.carriageFee.updateElement = updateElementForCarriageFee(
  existsElement,
  setContentToElement,
  addClass,
  removeClass,
  existsChildElement,
  "[name='carriage_fee']",
  '._is-lowest-price',
  '_is-checked',
  getElement,
  updateWcContent,
  setAttr,
  setCurrentAttr,
  setRestAttr,
  setDiscountedAttr,
  '#cart-bar',
  'shipping-fee-current',
  'shipping-fee-rest',
  'shipping-fee-discounted',
  '.price',
  '.postage-discount',
  'data-carriage-discount-line',
  '送料',
  removeAttr
);

window.cart.subtotal.carriageFee.updateGlobalVariableBeforeChange = updateGlobalVariableBeforeChange(
  existsElement,
  isEmptyText,
  updateGlobalVariable,
  existsChildElement,
  isChildElementForJustOne,
  updateGlobalVariableByChildElement,
  "[name='carriage_fee']",
  '.price',
  window,
  'beforeCurrentCarriageFee',
  getElement,
  updateGlobalVariableForWc,
  '#cart-bar',
  'shipping-fee-current'
);

window.cart.subtotal.carriageFee.updateGlobalVariableAfterChange = updateGlobalVariableAfterChange(
  existsElement,
  updateGlobalVariable,
  existsChildElement,
  updateGlobalVariableByChildElement,
  "[name='carriage_fee']",
  '.price',
  window,
  'currentCarriageFee',
  getElement,
  updateGlobalVariableForWc,
  '#cart-bar',
  'shipping-fee-current'
);

window.cart.subtotal.carriageFee.updateBeforeCurrentCarriageFeeLineVariable = updateGlobalVariableForSup(
  existsElement,
  updateGlobalVariable,
  updateGlobalVariableByAttr,
  '[data-carriage-discount-line]',
  '[data-carriage-discount-line]',
  'data-carriage-discount-line',
  window,
  'beforeCurrentCarriageFeeLine',
  getElement,
  updateGlobalVariableForWc,
  '#cart-bar',
  'shipping-fee-rest'
);

window.cart.subtotal.carriageFee.updateCurrentCarriageFeeLineVariable = updateGlobalVariableForSup(
  existsElement,
  updateGlobalVariable,
  updateGlobalVariableByAttr,
  '[data-carriage-discount-line]',
  '[data-carriage-discount-line]',
  'data-carriage-discount-line',
  window,
  'currentCarriageFeeLine',
  getElement,
  updateGlobalVariableForWc,
  '#cart-bar',
  'shipping-fee-rest'
);

window.cart.subtotal.frozenFee = {};

window.cart.subtotal.frozenFee.updateElement = updateElementForCarriageFee(
  existsElement,
  setContentToElement,
  addClass,
  removeClass,
  existsChildElement,
  "[name='frozen_fee']",
  '._is-lowest-price',
  '_is-checked',
  getElement,
  updateWcContent,
  setAttr,
  setCurrentAttr,
  setRestAttr,
  setDiscountedAttr,
  '#cart-bar',
  'freezing-fee-current',
  'freezing-fee-rest',
  'freezing-fee-discounted',
  '.frozen-fee',
  '.frozen-fee-discount',
  'data-frozen-discount-line',
  '冷凍手数料',
  removeAttr
);

window.cart.subtotal.frozenFee.updateGlobalVariableBeforeChange = updateGlobalVariableBeforeChange(
  existsElement,
  isEmptyText,
  updateGlobalVariable,
  existsChildElement,
  isChildElementForJustOne,
  updateGlobalVariableByChildElement,
  "[name='frozen_fee']",
  '.frozen-fee',
  window,
  'beforeCurrentFrozenFee',
  getElement,
  updateGlobalVariableForWc,
  '#cart-bar',
  'freezing-fee-current'
);

window.cart.subtotal.frozenFee.updateGlobalVariableAfterChange = updateGlobalVariableAfterChange(
  existsElement,
  updateGlobalVariable,
  existsChildElement,
  updateGlobalVariableByChildElement,
  "[name='frozen_fee']",
  '.frozen-fee',
  window,
  'currentFrozenFee',
  getElement,
  updateGlobalVariableForWc,
  '#cart-bar',
  'freezing-fee-current'
);

window.cart.subtotal.frozenFee.updateCurrentFrozenFeeLineVariable = updateGlobalVariableForSup(
  existsElement,
  updateGlobalVariable,
  updateGlobalVariableByAttr,
  '[data-frozen-discount-line]',
  '[data-frozen-discount-line]:eq(0)',
  'data-frozen-discount-line',
  window,
  'currentFrozenFeeLine',
  getElement,
  updateGlobalVariableForWc,
  '#cart-bar',
  'freezing-fee-rest'
);

window.cart.subtotal.frozenFee.updateBeforeCurrentFrozenFeeLineVariable = updateGlobalVariableForSup(
  existsElement,
  updateGlobalVariable,
  updateGlobalVariableByAttr,
  '[data-frozen-discount-line]',
  '[data-frozen-discount-line]:eq(0)',
  'data-frozen-discount-line',
  window,
  'beforeCurrentFrozenFeeLine',
  getElement,
  updateGlobalVariableForWc,
  '#cart-bar',
  'freezing-fee-rest'
);
